import { render } from "./UserSubscriptions.vue?vue&type=template&id=36b49836&scoped=true"
import script from "./UserSubscriptions.vue?vue&type=script&lang=js"
export * from "./UserSubscriptions.vue?vue&type=script&lang=js"

import "./UserSubscriptions.vue?vue&type=style&index=0&id=36b49836&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b49836"]])

export default __exports__